// 
// App Drawer
// 
export function useAppDrawer() {
  const isOpen = useState('app-drawer', () => false)

  const toggleDrawer = () => {
    isOpen.value = !isOpen.value
  }

  const openDrawer = () => {
    isOpen.value = true
  }

  const closeDrawer = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    toggleDrawer,
    openDrawer,
    closeDrawer,
  }
}